<template>
  <div class="row">
    <div class="col-md-12" :class="this.$store.state.amount !== '' && this.$store.state.amount !== 0 && this.$store.state.amount !== false ? [generalClass, validatedSectionClass] : []">
          <card-stripe v-if="publicKey" ref="cardStripe" v-on:validateSection="validateSection" :section="true">
          </card-stripe>
          <card-auth v-if="publicKey === ''" ref="cardAuth" v-on:validateSection="validateSection" :section="true">
          </card-auth>
    </div>
  </div>
</template>
<script>
import variables from '../../../../assets/sass/paper/_variables.scss'
import CardStripe from '../Utils/Card.vue'
import CardAuth from '../Utils/CardAuthorize.vue'
import {TranslationsUtils} from '../../../../utils/Translations'
export default {
  data () {
    return {
      publicKey: this.$store.state.configs.STRIPE_PUBLIC_KEY || '',
      primary: variables.primaryColor,
      secondary: variables.secondaryColor,
      validatedSectionClass: '',
      generalClass: 'general-inactive-section',
      disabled: false,
      title: this.$store.state.configs.LAB_NAME,
      model: {}
    }
  },
  components: {
    CardStripe,
    CardAuth
  },
  mixins: [TranslationsUtils],
  mounted: function () {
  },
  methods: {
    async validate () {
      if (this.$store.state.amount === 0) {
        return {valid: this.model}
      }
      if (this.publicKey === '') {
        this.model = await this.$refs.cardAuth.validate()
        return {payment_method: 'authorize', secureData: this.model, valid: this.model}
      } else {
        this.model = await this.$refs.cardStripe.validate()
        return {payment_method: 'stripe', stripeToken: this.model, valid: this.model}
      }
    },
    validateSection (booleanValue) {
      if (booleanValue) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/sass/paper/_variables.scss';
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

.display-none{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/PaymentSection.vue